import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components';
import { Button, TextField, Grid, FormControlLabel, MenuItem, IconButton, InputAdornment, Avatar } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../shared/components/PageTitle';
import { Loader } from '../../../shared/components/Loader';
import config from '../../config.json';
import { Formik } from 'formik';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { addUpdateUserProfile, getEmployeePicture, getManagerList, getUserProfileId } from '../../api';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(0),
  },
  withoutLabel: {
    marginTop: theme.spacing(0),
  },
  customToastProgress: {
    backgroundColor: '#F59300',
  },
}));

const UserWrapper = styled.div`
    position: relative;
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
        background-color: #F59300 !important;
    }
    .css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
        border : 1px solid #F59300 !important;
        color : #F59300 !important;
    }

    .wrapperWhite {
        background-color: #ffffff;
        padding: 1.5rem;
        border-radius: 18px;
    }

    .MuiTextField-root {
        width: 100%;
    }

    .card-box{
        position: relative;
        overflow: hidden;
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
        color: rgba(0, 0, 0, 0.87);
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        background-color: #fff;        
        cursor: pointer;
    }
    .card-indicator {
        position: absolute;
        height: 60%;
        top: 20%;
        width: 0px;
        border-top-right-radius: .75rem;
        border-bottom-right-radius: .75rem;
        left: 0;
        transition: all 0.3s linear;
    }
    .badge-primary {
        color: #fff;
        font-weight: 500;    
    }
    .roleName {
        font-size: 14px;
        font-weight: 500;
    }
    .roleItems { 
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .roleItems:checked ~ .card-indicator {
        width: 6px;
    }
    .customWidth : {
        width : 100% !important
    }
`;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Formats any input as a US phone number "(XXX) XXX-XXXX", keeping digits only (max 10).
// A leading country code "1" on an 11-digit value (e.g. from existing data) is dropped.
const formatPhone = (value) => {
  let digits = (value || "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }
  digits = digits.slice(0, 10);
  if (digits.length === 0) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const validatePhone = (value) => {
  const digits = (value || "").replace(/\D/g, "");
  if (digits.length > 0 && digits.length !== 10) {
    return "Enter a valid 10 digit phone number";
  }
  return undefined;
};

export default function AddUserProfile() {
  const classes = useStyles();
  const { id, email } = useParams();
  const token = config.TOKEN;
  const navigate = useNavigate();
  var [rows, setRows] = React.useState(
    {
      email: "",
      name: "",
      language: "",
      location: "",
      supervisorId: null,
      ecName: "",
      ecPhone: "",
      ecRel: "",
      phone: "",
      position: "",
      site: "",
      isSupervisor: false,
      portalLogin: false,
      password: "",
      profilePic: "",
      signaturePic: ""
    }
  );
  const fileInputRef = useRef(null);
  var [isSupervisor, setIsSupervisor] = React.useState(false);
  var [profilePic, setProfilePic] = React.useState(null);
  var [showProfilePic, setShowProfilePic] = React.useState(null);
  var [signaturePic, setSignaturePic] = React.useState(null);
  var [managerList, setManagerList] = React.useState([]);
  var [orgName, setOrgName] = React.useState(null);
  var [portalLogin, setPortalLogin] = React.useState(false);
  var [isProfilePicChanged, setIsProfilePicChanged] = React.useState(false);
  var [isSignaturePicChanged, setIsSignaturePicChanged] = React.useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const addUserProfile = () => toast("User Profile Added Successfully!", { progressClassName: classes.customToastProgress });
  const updateUserProfile = () => toast("User Profile Updated Successfully!", { progressClassName: classes.customToastProgress });
  const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

  const isSidebarOpen = useSelector(state => state.ThemeOptions.sidebarToggleMobile);

  const language = ["English", "French"];

  React.useEffect(() => {
    orgName = localStorage.getItem('orgName');
    setOrgName(orgName);

    const fetchUserProfile = async () => {
      if (id) {
        setLoading(true);
        await fetchEmployeePicture();
        try {
          const res = await getUserProfileId(id);
          if (res.data.successCode === 0) {
            rows = res.data.data[0]
            setRows(rows);
            isSupervisor = rows?.isSupervisor
            setIsSupervisor(isSupervisor);
            signaturePic = rows.signaturePic
            setSignaturePic(signaturePic);
            portalLogin = rows.portalLogin
            setPortalLogin(portalLogin);
          } else {
            errorMessage();
          }
        } catch (err) {
          errorMessage();
        }
        finally {
          setLoading(false);
        }
      } else {
        showProfilePic = true;
        setShowProfilePic(showProfilePic)
      }
    }
    fetchManagerList();
    fetchUserProfile();
  }, [])

  const fetchEmployeePicture = async () => {
    try {
      const res = await getEmployeePicture(email);
      if (res.data.successCode === 404) {
        showProfilePic = false;
        setShowProfilePic(showProfilePic);
        return
      } else if (res.data.successCode === -1) {
        showProfilePic = true;
        setShowProfilePic(showProfilePic);
        return
      } else if (res.data.successCode === 0) {
        const base64String = res.data.data.fileData;
        const employeePic = "data:image/png;base64," + base64String
        setProfilePic(employeePic);
        showProfilePic = true;
        setShowProfilePic(showProfilePic);
        return
      } else {
        errorMessage();
      }
    } catch {
      errorMessage();
    }
  }

  const fetchManagerList = async () => {
    try {
      const res = await getManagerList();
      if (res.data.successCode === 0) {
        const supervisor = res.data.data.filter(supervisor => supervisor.isSupervisor === true)
        setManagerList(supervisor);
      } else {
        errorMessage();
      }
    } catch (err) {
      errorMessage();
    }
  }

  const handleManagerChecked = (event) => {
    isSupervisor = event.target.checked
    setIsSupervisor(isSupervisor);
  }

  const handlePortalLogin = (event) => {
    portalLogin = event.target.checked
    setPortalLogin(portalLogin);
  }

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
        isProfilePicChanged = true
        setIsProfilePicChanged(isProfilePicChanged);
      }
      reader.readAsDataURL(file);
    }
  };

  const handleSignatureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSignaturePic(reader.result);
        isSignaturePicChanged = true
        setIsSignaturePicChanged(isSignaturePicChanged);
      }
      reader.readAsDataURL(file);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  if (loading) {
    return (
      <div className="d-flex align-items-center vh-100 justify-content-center text-center font-weight-bold font-size-lg py-3">
        <Loader color="#ff9900" />
      </div>
    );
  }

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={{
          Email: rows?.email,
          Name: rows?.name,
          QbName: rows?.qbName,
          Language: rows?.language,
          Location: rows?.location,
          supervisorId: rows?.supervisorId,
          isSupervisor: rows?.isSupervisor,
          portalLogin: rows?.portalLogin,
          Password: rows?.password,
          ConfirmPassword: rows?.password,
          EcName: rows?.ecName,
          EcPhone: formatPhone(rows?.ecPhone),
          EcRel: rows?.ecRel,
          Phone: formatPhone(rows?.phone),
          Position: rows?.position,
          profilePic: rows?.profilePic,
          signaturePic: rows?.signaturePic
        }}
        validate={values => {
          const errors = {}
          if (!values.Email) {
            errors.Email = "Required!"
          } else if (!EMAIL_REGEX.test(values.Email.trim())) {
            errors.Email = "Enter a valid email address"
          }
          const ecPhoneError = validatePhone(values.EcPhone);
          if (ecPhoneError) {
            errors.EcPhone = ecPhoneError
          }
          const phoneError = validatePhone(values.Phone);
          if (phoneError) {
            errors.Phone = phoneError
          }
          if (!values.Name) {
            errors.Name = "Required!"
          }
          if (!values.QbName && orgName === "Pike Group") {
            errors.QbName = "Required!"
          }
          if (portalLogin) {
            if (!values.Password) {
              errors.Password = "Required!"
            }
            if (values.Password !== values.ConfirmPassword) {
              errors.ConfirmPassword = "Passwords do not match!"
            }
          }
          return errors;
        }}

        const handleMouseDownPwd={(event) => {
          event.preventDefault();
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const postData = {
            id: id ? id : 0,
            email: values.Email.trim(),
            name: values.Name,
            qbName: values.QbName,
            language: values.Language,
            location: values.Location,
            supervisorId: values.supervisorId,
            ecName: values.EcName,
            ecPhone: values.EcPhone,
            ecRel: values.EcRel,
            phone: values.Phone,
            position: values.Position,
            isSupervisor: isSupervisor,
            portalLogin: portalLogin,
            password: portalLogin ? values.Password : "",
            profilePic: profilePic,
            signaturePic: signaturePic,
            profilePicChanged: isProfilePicChanged,
            signaturePicChanged: isSignaturePicChanged
          }

          try {
            const res = await addUpdateUserProfile(postData)
            if (res.data.successCode === 0) {
              { id ? updateUserProfile() : addUserProfile() }
            } else {
              errorMessage()
            }
            setTimeout(() => { navigate("/userProfile/list") }, 3000)
          } catch (err) {
            errorMessage();
            setTimeout(() => { navigate("/userProfile/list") }, 3000)
          }
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <UserWrapper>
              <ToastContainer theme="dark" />
              <div style={{ position: "relative" }}>

                {showProfilePic == true && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-50px",
                      left: isSidebarOpen ? "200px" : "160px",
                      zIndex: 99999,
                      transition: "left 0.5s ease",
                    }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleProfileChange}
                      style={{ display: "none" }}
                      ref={fileInputRef}
                    />

                    <Avatar
                      src={profilePic}
                      alt="profilePic"
                      style={{
                        width: 140,
                        height: 140,
                        cursor: "pointer",
                        border: "4px solid white",
                      }}
                      onClick={() => fileInputRef.current.click()}
                    />
                  </div>
                )}
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6} md={6}>
                    <PageTitle style={{ marginTop: "30px" }}> User Profile </PageTitle>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} className="text-right">

                  </Grid>
                </Grid>
              </div>
              <br></br>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6} className="pt-3">
                  <TextField label="Email" variant="standard" name="Email" value={values.Email || ""} onChange={handleChange} onBlur={handleBlur} autoComplete="new-email" />
                  <span className="errMsg">{errors.Email && touched.Email && errors.Email}</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className="pt-3">
                  <TextField label="Full Name" variant="standard" name="Name" value={values.Name || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.Name && touched.Name && errors.Name}</span>
                </Grid>
              </Grid>
              <br></br>

              <Grid container spacing={4}>
                {orgName === "Pike Group" && <Grid item xs={12} sm={6} md={6}>
                  <TextField label="QuickBooks Name" variant="standard" name="QbName" value={values.QbName || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.QbName && touched.QbName && errors.QbName}</span>
                </Grid>}
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    style={{ width: "99%" }}
                    className="filterDropdown"
                    id="status"
                    select
                    label="Select Language"
                    helperText=""
                    variant="standard"
                    name="Language"
                    value={values.Language || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}>
                    {language.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                  <span className="errMsg">{errors.Language && touched.Language && errors.Language}</span>
                </Grid>
              </Grid>
              <br></br>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Location" variant="standard" name="Location" value={values.Location || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.Location && touched.Location && errors.Location}</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    style={{ width: "99%" }}
                    className="filterDropdown"
                    id="status"
                    select
                    label="Select Manager"
                    helperText=""
                    variant="standard"
                    name="supervisorId"
                    value={values.supervisorId || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}>
                    {managerList.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  {/* <span className="errMsg">{errors.Supervisor && touched.Supervisor && errors.Supervisor}</span> */}
                </Grid>
              </Grid>
              <br></br>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Emergency contact name" variant="standard" name="EcName" value={values.EcName || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.EcName && touched.EcName && errors.EcName}</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Emergency contact phone" variant="standard" name="EcPhone" placeholder="(555) 123-4567" value={values.EcPhone || ""} onChange={(e) => setFieldValue("EcPhone", formatPhone(e.target.value))} onBlur={handleBlur} inputProps={{ inputMode: "numeric" }} />
                  <span className="errMsg">{errors.EcPhone && touched.EcPhone && errors.EcPhone}</span>
                </Grid>
              </Grid>
              <br></br>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Emergency contact relationship" variant="standard" name="EcRel" value={values.EcRel || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.EcRel && touched.EcRel && errors.EcRel}</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Phone" variant="standard" name="Phone" placeholder="(555) 123-4567" value={values.Phone || ""} onChange={(e) => setFieldValue("Phone", formatPhone(e.target.value))} onBlur={handleBlur} inputProps={{ inputMode: "numeric" }} />
                  <span className="errMsg">{errors.Phone && touched.Phone && errors.Phone}</span>
                </Grid>
              </Grid>
              <br></br>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField label="Position" variant="standard" name="Position" value={values.Position || ""} onChange={handleChange} onBlur={handleBlur} />
                  <span className="errMsg">{errors.Position && touched.Position && errors.Position}</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6} style={{ marginTop: '18px' }}>
                  <FormControlLabel control={<Checkbox
                    checked={isSupervisor}
                    style={{ color: "#F59300" }}
                    onChange={(event) => handleManagerChecked(event)}
                  />}
                    label="Supervisor"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControlLabel control={<Checkbox
                    checked={portalLogin}
                    style={{ color: "#F59300" }} />}
                    onChange={(event) => handlePortalLogin(event)}
                    label="Portal Login" />
                </Grid>
              </Grid>
              <br></br>

              <Grid container spacing={4}>
                {portalLogin && (
                  <>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField label="Password" variant="standard" name="Password" type={showPassword ? "text" : "password"} value={values.Password || ""} onChange={handleChange} onBlur={handleBlur} autoComplete="new-password" InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }} />
                      <span className="errMsg">{errors.Password && touched.Password && errors.Password}</span>
                    </Grid>
                    <Grid item xs sm={6} md={6}>
                      <TextField label="Retype Password" variant="standard" name="ConfirmPassword" type={showConfirmPassword ? "text" : "password"} value={values.ConfirmPassword || ""} onChange={handleChange} onBlur={handleBlur} autoComplete="new-password" InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowConfirmPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }} />
                      <span className="errMsg">{errors.ConfirmPassword && touched.ConfirmPassword && errors.ConfirmPassword}</span>
                    </Grid>
                  </>
                )}
              </Grid>
              <br></br>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={6}>
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6}>
                  <label style={{ display: 'block', marginBottom: '8px' }}>Signature</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleSignatureChange}
                  />
                  {signaturePic && (
                    <div style={{
                      position: 'relative',
                      padding: 6,
                      width: 300,
                      height: 100,
                      marginTop: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#f9f9f9',
                    }}>
                      <img
                        src={signaturePic}
                        alt="signaturePic"
                        style={{ width: '100%', height: '100%', objectFit: 'fill' }}
                      />
                    </div>
                  )}
                </Grid> */}
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={12} className="text-right mt-4">
                  <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => navigate("/userProfile/list")}>
                    Cancel
                  </Button>&nbsp;&nbsp;
                  <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting}>
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </UserWrapper>
          </form>
        )}
      </Formik>
    </div>
  )
}
